import PetsIcon from "@mui/icons-material/Pets";
import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { SingleBoxContext } from "../../../../../../contexts/BoxProvider";
import { capitalizeFirstLetter } from "../../../../../../utils/Functions";
import { calculateAge } from "../../../../../pets/utils/Functions";
import AddPetToBox from "../../../../components/forms/AddPetToBox";
import HorizontalStack from "../../../../components/wrappers/HorizontalStack";
import { single_box_view_title_size } from "../../SingleBoxView";
import { petViewUrl } from "../../../../../../enums/UrlPaths";
import PetActions from "./PetActions";
import useCheckPath from "../../../../../../hooks/useCheckPath";

export default function PetList({ pets = [], boxName = null }) {
  const { setPetsInBox } = React.useContext(SingleBoxContext);

  React.useEffect(() => {
    setPetsInBox(pets);
  }, [pets]);

  const { t } = useTranslation();

  if (!pets || pets.length == 0) {
    return (
      <Wrapper boxName={boxName}>
        <Typography color="grayText" variant="subtitle2">
          {t("NoPetsFoundForThisBox")}
        </Typography>
      </Wrapper>
    );
  }

  return (
    <Wrapper boxName={boxName}>
      <List>
        {pets.map((pet, index) => (
          <Box key={pet.id} sx={{ mt: 1 }}>
            <SinglePet pet={pet} />
          </Box>
        ))}
      </List>
    </Wrapper>
  );
}

function SinglePet({ pet }) {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <HorizontalStack sx={{ alignItems: "center" }}>
        <ListItem
          key={pet.id}
          onClick={() => navigate(petViewUrl(pet.id, pet.userId))}
        >
          <ListItemIcon>
            <PetsIcon color="primary" />
          </ListItemIcon>
          <ListItemText
            sx={{
              "&:hover": {
                cursor: "pointer",
              },
            }}
            primary={pet.name}
            secondary={getSecondary(pet, t)}
          />
        </ListItem>
        <PetActions pet={pet} />
      </HorizontalStack>
    </>
  );
}

function getSecondary(pet, t) {
  var string = "";
  const species = capitalizeFirstLetter(pet?.type?.title);
  const breed = pet?.breed;
  const birthdate = calculateAge(pet?.birthdate, t);
  const weight = pet?.lastWeight?.trim();
  const temperature = pet?.lastTemperature?.trim();

  string = species;

  if (breed) {
    string = `${string} • ${t(breed)}`;
  }

  if (birthdate) {
    string = `${string} • ${birthdate}`;
  }

  if (weight) {
    string = `${string} • ${t("Mass")}: ${weight}`;
  }

  if (temperature) {
    string = `${string} • ${t("temperature")}: ${temperature}`;
  }

  return string;
}

function Wrapper({ children, boxName }) {
  const { id } = useParams();
  const { t } = useTranslation();
  const isArchived = useCheckPath();

  return (
    <Card>
      <CardContent>
        <HorizontalStack>
          {isArchived ? null : <Typography variant={single_box_view_title_size} gutterBottom>
            {t("PetsInBox")}
            {boxName ? `: ${boxName}` : `#${id}`}
          </Typography>}
          {isArchived ? null : <AddPetToBox />}
        </HorizontalStack>
        {children}
      </CardContent>
    </Card>
  );
}
